import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import { FC } from 'react';

import { Provider } from 'react-redux';
import { Provider as MicrofrontendProvider } from '@cian/mf-react';

import { IApplicationContext } from 'shared/types/applicationContext';
import { TReduxStore } from 'shared/types/redux';
import { ApplicationContext } from 'shared/utils/applicationContext';

import { PageContainer } from '../Page';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
  ssrHtml?: string;
}

export const Application: FC<IApplicationProps> = ({ reduxStore, context, ssrHtml }) => {
  const {
    logger,
    custom: { initialDeviceType },
  } = context;

  // oxlint-disable-next-line react/no-danger
  const errorStub = ssrHtml ? <div dangerouslySetInnerHTML={{ __html: ssrHtml }} /> : undefined;

  return (
    <ErrorLogComponent logger={logger} errorStub={errorStub}>
      <ApplicationContext.Provider value={context}>
        <UiKitContextProvider deviceType={initialDeviceType}>
          <MicrofrontendProvider registry={context.microfrontendsRegistry}>
            <Provider store={reduxStore}>
              <PageContainer />
            </Provider>
          </MicrofrontendProvider>
        </UiKitContextProvider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
